module.exports = __webpack_public_path__ + "static/media/postcert.4eb77b3e.png";